import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import RolesPermissionsMobile from "../mobile/admin/RolesPermissionsMobile";
import GestionRolesPermissions from "./GestionRolesPermissions";

export default function ResponsiveGestionRolesPermissions(props) {
  return useIsMobile() ? <RolesPermissionsMobile {...props} /> : <GestionRolesPermissions {...props} />;
}
